var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgKlarna = function SvgKlarna(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-6 -4 26 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB3C7",
    d: "M-6 -4h26v20H-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.79 8.682a1.409 1.409 0 1 0 0 2.818 1.409 1.409 0 0 0 0-2.818ZM9.454.5H7.019a6.227 6.227 0 0 1-2.517 5.025l-.964.723 3.737 5.096h3.072L6.91 6.654A8.626 8.626 0 0 0 9.454.5ZM3.24.5H.8v10.844h2.44V.5Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKlarna);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9Ii02IC00IDI2IDIwIj4KICA8cGF0aCBmaWxsPSIjRkZCM0M3IiBkPSJNLTYgLTRoMjZ2MjBILTZ6Ii8+CiAgPHBhdGggZmlsbD0iIzAwMCIgZD0iTTExLjc5IDguNjgyYTEuNDA5IDEuNDA5IDAgMSAwIDAgMi44MTggMS40MDkgMS40MDkgMCAwIDAgMC0yLjgxOFpNOS40NTQuNUg3LjAxOWE2LjIyNyA2LjIyNyAwIDAgMS0yLjUxNyA1LjAyNWwtLjk2NC43MjMgMy43MzcgNS4wOTZoMy4wNzJMNi45MSA2LjY1NEE4LjYyNiA4LjYyNiAwIDAgMCA5LjQ1NC41Wk0zLjI0LjVILjh2MTAuODQ0aDIuNDRWLjVaIi8+Cjwvc3ZnPg==";